import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 60000, // 60s — cPanel host can be slow, especially on first request
});

export default api;



